import { acceptStatuses } from '../lib/axios';
import { get } from 'axios';

export const getGenders = async () => {
  const { data } = await get('/api/client/genders');
  return data;
};

export const getCountries = async () => {
  const { data } = await get('/api/client/countries');
  return data;
};

export const getClientId = async () => {
  const { data } = await get('/api/client/id');
  return data;
};

export const getClientConfig = async () => {
  const data = await get('/api/client/config', {
    validateStatus: acceptStatuses(200, 401),
  });

  if (data?.errors) {
    return null;
  }

  return data;
};
